import ApiService from './api.service';

class CategoryService {
  async list() {
    try {
      const response = await ApiService.get('/category');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(categoryData) {
    try {
      const response = await ApiService.post('/category/add', categoryData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(categoryData) {
    try {
      const response = await ApiService.put('/category/update', categoryData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(categoryId) {
    try {
      const response = await ApiService.delete('/category/delete', { id: categoryId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new CategoryService();